<li *ngIf="folder">
  <div
    class="flex items-center gap-2 my-2"
    [draggable]="false"
    (dragover)="allowDrop($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event, folder)">
    <div
      class="flex gap-1 cursor-pointer hover:text-gray-500 {{ isHovering ? 'text-gray-500' : '' }}"
      [ngClass]="{ 'text-blue-500': folder.id === selectedId }"
      (click)="selectItem(folder.id)">
      <mat-icon class="flex" fontIcon="{{ folder.id === selectedId ? 'folder_open' : 'folder' }}" />
      <div class="leading-7">
        {{ folder.name }}
        <span *ngIf="isLocked"><i class="pi pi-lock"></i> </span>
      </div>
    </div>
    <div *ngIf="folder.children && folder.children.length > 0">
      <button type="button" class="flex" (click)="isOpen = !isOpen">
        <mat-icon fontIcon="{{ isOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}" />
      </button>
    </div>
  </div>

  <ul *ngIf="isOpen && folder.children && folder.children.length > 0">
    <li *ngFor="let child of folder.children" class="ml-3">
      <offconon-folder-item
        [folder]="child"
        [selectedId]="selectedId"
        [user_id]="user_id"
        [business_id]="business_id"
        [selectedChildrenParents]="selectedChildrenParents"
        (selectedIdEmit)="selectedIdEmit.emit($event)" />
    </li>
  </ul>
</li>

<p-dialog
  header="{{ 'Enter password' | translate }}"
  [appendTo]="'body'"
  [modal]="true"
  [closeOnEscape]="true"
  [resizable]="true"
  [closable]="true"
  [dismissableMask]="true"
  [maximizable]="true"
  [style]="{ width: '50rem' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [(visible)]="passwordCheck"
  (onHide)="closeDialog()">
  <div class="p-2">
    <div class="pt-3">
      @if (passwordCheck) {
        <offconon-folder-password-form
          [album_id]="folder.id"
          [user_id]="user_id"
          (passwordCheckEvent)="passwordChecked($event)" />
      }
    </div>
  </div>
</p-dialog>
